import React, { useState } from "react";

export const LinksNetwork = () => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div className="list-network">
      <a
        target="_blank"
        href="https://vc.ru/u/331647-elena-nazarova"
        rel="noopener noreferrer"
        onMouseOver={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <img
          width="32"
          height="32"
          src={`/img/vcru-${isHover ? "orange" : "black"}.svg`}
          alt=""
        />
      </a>
      <a
        target="_blank"
        href="https://twitter.com/ItFox_web"
        rel="noopener noreferrer"
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.3272 29.6652C23.6919 29.6652 29.6622 23.6949 29.6622 16.3302C29.6622 8.96542 23.6919 2.99512 16.3272 2.99512C8.96247 2.99512 2.99219 8.96542 2.99219 16.3302C2.99219 23.6949 8.96247 29.6652 16.3272 29.6652Z"
            fill="#141414"
          />
          <path
            d="M8.1183 8.60449L14.4923 17.127L8.07812 24.0562H9.52181L15.1375 17.9894L19.6747 24.0562H24.5872L17.8545 15.0544L23.8248 8.60449H22.3811L17.2095 14.1917L13.0309 8.60449H8.1183ZM10.2413 9.66779H12.4981L22.464 22.9929H20.2071L10.2413 9.66779Z"
            fill="white"
          />
        </svg>
      </a>
      <a
        target="_blank"
        href="https://t.me/itfox_webs"
        rel="noopener noreferrer"
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.9974 29.3337C8.6334 29.3337 2.66406 23.3643 2.66406 16.0003C2.66406 8.63633 8.6334 2.66699 15.9974 2.66699C23.3614 2.66699 29.3307 8.63633 29.3307 16.0003C29.3307 23.3643 23.3614 29.3337 15.9974 29.3337ZM11.8507 17.5603L11.8681 17.551L13.0281 21.3777C13.1774 21.7923 13.3827 21.867 13.6321 21.8323C13.8827 21.799 14.0147 21.6643 14.1787 21.507L15.7627 19.9763L19.1627 22.4937C19.7841 22.8363 20.2307 22.659 20.3854 21.9177L22.5947 11.4883C22.8387 10.5177 22.4121 10.1283 21.6587 10.4377L8.6814 15.451C7.79606 15.8057 7.8014 16.3017 8.5214 16.5217L11.8507 17.5617V17.5603Z"
            fill="white"
          />
        </svg>
      </a>
      <a
        target="_blank"
        href="https://vk.com/itfox_web"
        rel="noopener noreferrer"
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.2938 8.25C30.5163 7.545 30.2938 7.0325 29.3094 7.0325H26.0362C25.2106 7.0325 24.8294 7.48125 24.6069 7.96125C24.6069 7.96125 22.9231 12.0612 20.5719 14.7194C19.8094 15.4881 19.46 15.7444 19.0469 15.7444C18.8244 15.7444 18.5381 15.4881 18.5381 14.7837V8.21688C18.5381 7.38438 18.2844 7 17.585 7H12.4375C11.9288 7 11.6112 7.38438 11.6112 7.76875C11.6112 8.56938 12.7869 8.76187 12.9137 11.0037V15.875C12.9137 16.9319 12.7263 17.125 12.31 17.125C11.1981 17.125 8.4975 12.9931 6.8775 8.285C6.5625 7.3525 6.2425 7 5.41625 7H2.11188C1.15875 7 1 7.44813 1 7.92875C1 8.79375 2.11188 13.1494 6.17875 18.9144C8.87937 22.8519 12.7237 24.9681 16.1869 24.9681C18.2844 24.9681 18.5381 24.4875 18.5381 23.6869V20.7081C18.5381 19.7475 18.7288 19.5875 19.3962 19.5875C19.8725 19.5875 20.7306 19.8431 22.6688 21.7331C24.8925 23.975 25.2738 25 26.5131 25H29.7856C30.7388 25 31.1838 24.5194 30.9294 23.5906C30.6437 22.6619 29.5631 21.3169 28.165 19.7156C27.4025 18.8194 26.2587 17.8263 25.9094 17.3456C25.4331 16.705 25.56 16.4488 25.9094 15.8725C25.8775 15.8725 29.8813 10.1713 30.2938 8.2475"
            fill="white"
          />
        </svg>
      </a>
      <a
        target="_blank"
        href="https://pin.it/2HXp0L7"
        rel="noopener noreferrer"
      >
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.9974 0.666504C16.4145 0.666504 18.6446 1.26689 20.6875 2.46767C22.7303 3.65286 24.3444 5.26689 25.5296 7.30978C26.7303 9.35266 27.3307 11.5827 27.3307 13.9998C27.3307 16.417 26.7303 18.647 25.5296 20.6899C24.3444 22.7328 22.7303 24.3546 20.6875 25.5554C18.6446 26.7406 16.4145 27.3332 13.9974 27.3332C12.6719 27.3332 11.3541 27.1382 10.0442 26.7484C10.9175 25.2981 11.4711 24.1285 11.705 23.2396L12.5237 20.0817C12.7576 20.5028 13.1631 20.8614 13.7401 21.1577C14.3171 21.454 14.9331 21.6022 15.588 21.6022C16.898 21.6022 18.0754 21.2357 19.1202 20.5028C20.1806 19.7542 21.0071 18.7484 21.5997 17.4852C22.2079 16.2221 22.512 14.8341 22.512 13.3215C22.512 11.8712 22.1455 10.5612 21.4126 9.39165C20.6953 8.20646 19.705 7.27859 18.4418 6.60802C17.1943 5.93746 15.8064 5.60218 14.2781 5.60218C12.4379 5.60218 10.8551 5.97645 9.52956 6.72498C8.20402 7.45793 7.19818 8.44038 6.51202 9.67235C5.82586 10.9043 5.48278 12.2377 5.48278 13.6724C5.48278 14.7172 5.73229 15.7464 6.23131 16.7601C6.73034 17.7737 7.38531 18.4677 8.19623 18.8419C8.32098 18.9043 8.41455 18.9199 8.47693 18.8887C8.5549 18.8575 8.60948 18.7796 8.64067 18.6548L9.01494 17.1577C9.04613 17.0174 9.01494 16.8926 8.92137 16.7835C8.62508 16.4404 8.38336 15.9881 8.19623 15.4267C8.00909 14.8653 7.91552 14.3039 7.91552 13.7425C7.91552 12.7445 8.15724 11.801 8.64067 10.9121C9.1241 10.0232 9.82586 9.30588 10.7459 8.76007C11.666 8.21426 12.7342 7.94136 13.9506 7.94136C15.0266 7.94136 15.9857 8.17528 16.8278 8.64311C17.6699 9.09536 18.3249 9.73473 18.7927 10.5612C19.2761 11.3878 19.5179 12.3234 19.5179 13.3683C19.5179 14.5534 19.3307 15.6139 18.9565 16.5495C18.5978 17.4696 18.0988 18.187 17.4594 18.7016C16.82 19.2162 16.1027 19.4735 15.3073 19.4735C14.8707 19.4735 14.4808 19.3644 14.1377 19.146C13.8103 18.9277 13.5685 18.6392 13.4126 18.2805C13.2722 17.9063 13.2489 17.5008 13.3424 17.0642C13.4204 16.7679 13.4984 16.4794 13.5763 16.1987C13.6699 15.9024 13.7557 15.6061 13.8337 15.3098C14.052 14.608 14.2079 14.0622 14.3015 13.6724C14.3951 13.2825 14.4418 12.9316 14.4418 12.6197C14.4418 12.0895 14.2937 11.6451 13.9974 11.2864C13.7167 10.9277 13.3034 10.7484 12.7576 10.7484C12.0871 10.7484 11.5179 11.0603 11.05 11.684C10.5822 12.3078 10.3483 13.0798 10.3483 13.9998C10.3483 14.7484 10.4808 15.4033 10.7459 15.9648L9.17868 22.5846C8.97595 23.5359 8.96036 24.8147 9.1319 26.4209C7.47888 25.7815 6.01299 24.8458 4.73424 23.6139C3.45549 22.3663 2.45744 20.916 1.74009 19.263C1.02274 17.61 0.664062 15.8556 0.664062 13.9998C0.664062 11.5827 1.25666 9.35266 2.44184 7.30978C3.64262 5.26689 5.26445 3.65286 7.30734 2.46767C9.35022 1.26689 11.5802 0.666504 13.9974 0.666504Z"
            fill="white"
          />
        </svg>
      </a>
      <a
        target="_blank"
        href="https://www.linkedin.com/company/itfoxweb/"
        rel="noopener noreferrer"
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.4467 24.452H20.8933V18.8827C20.8933 17.5547 20.8667 15.8453 19.04 15.8453C17.188 15.8453 16.9053 17.2907 16.9053 18.7853V24.452H13.3507V13H16.764V14.56H16.8107C17.288 13.6613 18.448 12.7107 20.1813 12.7107C23.7813 12.7107 24.448 15.0813 24.448 18.1653V24.452H24.4467ZM9.33733 11.4333C9.06607 11.4337 8.79741 11.3805 8.54675 11.2768C8.29609 11.1731 8.06836 11.021 7.87661 10.8291C7.68486 10.6372 7.53287 10.4094 7.42935 10.1587C7.32582 9.90795 7.27281 9.63926 7.27333 9.368C7.2736 8.95978 7.39491 8.5608 7.62192 8.22153C7.84894 7.88225 8.17146 7.61791 8.54871 7.46194C8.92595 7.30596 9.34098 7.26536 9.74131 7.34525C10.1416 7.42515 10.5093 7.62197 10.7977 7.91081C11.0862 8.19965 11.2826 8.56755 11.3619 8.96798C11.4413 9.3684 11.4002 9.78338 11.2437 10.1604C11.0872 10.5375 10.8225 10.8597 10.4829 11.0862C10.1434 11.3128 9.74422 11.4336 9.336 11.4333H9.33733ZM11.1187 24.452H7.55467V13H11.12V24.452H11.1187ZM26.2267 4H5.772C4.79067 4 4 4.77333 4 5.72933V26.2707C4 27.2267 4.792 28 5.77067 28H26.2213C27.2 28 28 27.2267 28 26.2707V5.72933C28 4.77333 27.2 4 26.2213 4H26.2253H26.2267Z"
            fill="white"
          />
        </svg>
      </a>
    </div>
  );
};
